export default "__VITE_ASSET__c6a411d0__"